<div class="enhanced-view-container" onsip-grid-placement-shelf>
  <div class="first-column">
    <section class="blf">
      <div class="mat-body-2">{{ getPricingText() }}</div>
      <div class="mat-body-2">
        Includes basic queue features, plus reporting and call recording capabilities
      </div>
      <span class="enhanced-slide-toggle">
        <mat-slide-toggle
          color="primary"
          [formControl]="enhanced"
          (change)="toggleEnhanced($event)"
        ></mat-slide-toggle>
        <div class="blf-hint">Enable enhanced queue (optional)</div>
      </span>
    </section>
  </div>
  <div class="second-view-column">
    @if (showEnhancedFields) {
    <div>
      <section class="property">
        <div class="mat-body-1 property-header">Enable queue reporting</div>
        <div>{{ queueReportingEnabled ? "Yes" : "No" }}</div>
      </section>
      <section class="property">
        <div class="mat-body-1 property-header">Enable call recording</div>
        <div>{{ callRecordingEnabled ? "Yes" : "No" }}</div>
      </section>
      @if (callRecordingEnabled) {
      <div>
        <section class="property">
          <div class="mat-body-1 property-header">Storage service</div>
          <div>{{ queue.storageServiceName }}</div>
        </section>
        <section class="property">
          <div class="mat-body-1 property-header">Recording Announcement</div>
          @if (queue.announceRecording === '') {
          <div>None</div>
          } @if (queue.announceRecording === 'basic') {
          <div>Your call may be recorded.</div>
          } @if (queue.announceRecording === 'training') {
          <div>Your call may be recorded for quality assurance and training purposes.</div>
          } @if (queue.announceRecording === 'monitored') {
          <div>Your call may be monitored or recorded for quality assurance.</div>
          }
        </section>
        <section class="property">
          <div class="mat-body-1 property-header">
            Play a tone periodically during call recording
          </div>
          <div>{{ queue.recordingTone ? "Yes" : "No" }}</div>
        </section>
      </div>
      }
    </div>
    }
  </div>
  <div class="third-view-column">
    @if (showEnhancedFields && queueReportingEnabled) {
    <section class="property">
      <div class="mat-body-1 property-header">Email reports</div>
      @for (emailRepText of emailReportsTextList; track emailRepText) {
      <div>
        <span [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_VIEW_SHELVE_ENHANCED_EMAIL">
          {{ emailRepText }}
        </span>
      </div>
      }
    </section>
    }
  </div>
</div>
@if (showEnhancedFields) {
<div class="page-view-controls">
  <button
    mat-flat-button
    class="toggle-button"
    color="primary"
    (click)="togglePanel()"
    [attr.data-cy]="E2eLocators.ADMIN_ACD_QUEUE_VIEW_SHELVE_EDIT_BUTTON"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
}
